export enum Environment {
  Test = 'test',
  Local = 'local',
  Development = 'development',
  Production = 'production',
}

export const MAX_INT_32 = 2147483647;

export const MAX_AGE_RESTRICTION_COLUMN_LENGTH = 7;

export const ImageRatio = 3 / 2;
